import { render, staticRenderFns } from "./AiSyntaxIfEditor.vue?vue&type=template&id=181040a8&scoped=true&"
import script from "./AiSyntaxIfEditor.vue?vue&type=script&lang=ts&"
export * from "./AiSyntaxIfEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AiSyntaxIfEditor.vue?vue&type=style&index=0&id=181040a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181040a8",
  null
  
)

export default component.exports